
import L from "leaflet";
import "leaflet-iconmaterial";
import { useEffect, useMemo, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import { useTranslation } from "react-i18next";
import { Marker } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import {
  useActualLayer,
  useActualPlaceholder,
  useDisplayedPlaceholders
} from "Utils/hooks";
import LeafletMarker from "./LeafletMarker";
import LeafletPopup from "./LeafletPopup";

//maker leaflet déplaçable
const StandardLeafletMarker = ({
  position,
  marker,
  id,
  parentId,
  children,
  target,
}) => {
  const { t } = useTranslation();
  const { activePlaceholderId, set, data } = useActualPlaceholder(parentId);
  const { setFilter, clearFilters } = useDisplayedPlaceholders();
  const { set: setLayer } = useActualLayer();
  const navigate = useNavigate();


  const isActive = useMemo(
    () => activePlaceholderId === id,
    [activePlaceholderId]
  );
  const markerRef = useRef(null);

  const handleMarkerClick = () => {
    
    if (target?.type === "mapLink") {
      navigate("/indoor");
    }
    if (children?.length >= 1) {
      isActive ? clearFilters() : setFilter({ placeholderId: id });
    } else if (target?.type === "layerLink") {
      clearFilters();
      return setLayer(target?.id);
    } else {
      markerRef.current?.openPopup();
      set(id);
    }
  };

  const eventHandlers = useMemo(
    () => ({
      click() {
        const marker = markerRef.current;
        if (marker != null) {
          handleMarkerClick();
        }
      },
    }),
    [activePlaceholderId, isActive, id]
  );

  useEffect(() => {
    let timeout
    // isActive && console.log('markerRef.current:', markerRef.current)
    isActive ? timeout = setTimeout(() => markerRef.current?.openPopup(), 1500) : markerRef.current?.closePopup();
    return () => clearTimeout(timeout);
  }, [isActive]);



  return (
    <Marker
      eventHandlers={eventHandlers}
      position={[position?.y, position?.x]}
      ref={markerRef}
      icon={L.divIcon({
        className: "custom icon",
        html: ReactDOMServer.renderToString(
          <LeafletMarker {...marker} isActive={isActive} />
        ),
      })}
    >
      <LeafletPopup data={data} target={target} position={position}/>
    </Marker>
  );
};

export default StandardLeafletMarker;
